import type { Provider } from '@angular/core';

import { PROJECTS_TRANSLOCO } from './projects.transloco';
import { ProjectsStore } from './stores/projects.store';

/**
 * Route-scoped providers for the `projects` parent route (Q32/C4 — see
 * `KT-198.1-my_projects-k1-alignment.md` "Q32 (FE-2 előtt)").
 *
 * `ProjectsStore` is deliberately **not** `providedIn: 'root'`: it is
 * scoped to the `projects` route subtree so a fresh store (and fresh
 * in-flight state) is created on route activation and torn down on
 * navigation away — no leaking into `/` or other feature routes. This
 * mirrors the route-scoped Transloco precedent used for the other `kt.routes.ts`
 * children, but loads the projects-domain catalog only (`PROJECTS_TRANSLOCO`).
 *
 * FE-2 establishes this constant and the store it provides only. FE-3 owns
 * wiring it onto the real `projects` parent route in `kt.routes.ts`
 * alongside `profileGuard` and the `''` / `:projectId` child routes — e.g.:
 *
 * ```ts
 * {
 *   path: 'projects',
 *   canActivate: [profileGuard],
 *   providers: PROJECTS_ROUTE_PROVIDERS,
 *   children: [
 *     { path: '', loadComponent: () => import('./projects/pages/projects-list-page/projects-list-page') },
 *     { path: ':projectId', loadComponent: () => import('./projects/pages/project-detail-page/project-detail-page') },
 *   ],
 * }
 * ```
 */
export const PROJECTS_ROUTE_PROVIDERS: Provider[] = [ProjectsStore, PROJECTS_TRANSLOCO.provider];
